"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = image;
var _getClosestTranslationTarget = require("../utils/getClosestTranslationTarget");
/**
 * Only to be used with nature category translates
 * @param  {string} value
 * @param  {string} category 'nature'
 * @param  {string} extension ['svg', 'png']
 * @param  {string} dataSource 'norway'
 * @þaram  {string} baseUrl
 * @returns {{string}} url
 */
function image(_ref) {
  var value = _ref.value,
    category = _ref.category,
    extension = _ref.extension,
    dataSource = _ref.dataSource,
    baseUrl = _ref.baseUrl;
  var closestTarget = (0, _getClosestTranslationTarget.getClosestTranslationTarget)(value, category, dataSource);
  return {
    url: "".concat(baseUrl).concat(category, "_").concat(closestTarget, ".").concat(extension)
  };
}
//# sourceMappingURL=index.js.map